module.exports = __webpack_public_path__ + "81117fe192f85492d5a0a4e2465b11d0.svg";